/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Mark_As_Done_LabelInputs */

const en_notes_mark_as_done_label = /** @type {(inputs: Notes_Mark_As_Done_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark as done`)
};

const fr_notes_mark_as_done_label = /** @type {(inputs: Notes_Mark_As_Done_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marquer comme termine`)
};

const de_notes_mark_as_done_label = /** @type {(inputs: Notes_Mark_As_Done_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als erledigt markieren`)
};

const it_notes_mark_as_done_label = /** @type {(inputs: Notes_Mark_As_Done_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segna come fatto`)
};

const ru_notes_mark_as_done_label = /** @type {(inputs: Notes_Mark_As_Done_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отметить как выполненное`)
};

const es_notes_mark_as_done_label = /** @type {(inputs: Notes_Mark_As_Done_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcar como hecho`)
};

const zh_cn2_notes_mark_as_done_label = /** @type {(inputs: Notes_Mark_As_Done_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标记为已完成`)
};

const ja_notes_mark_as_done_label = /** @type {(inputs: Notes_Mark_As_Done_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了としてマーク`)
};

const hi_notes_mark_as_done_label = /** @type {(inputs: Notes_Mark_As_Done_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्ण हुआ चिह्नित करें`)
};

const pt_pt2_notes_mark_as_done_label = /** @type {(inputs: Notes_Mark_As_Done_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcar como concluído`)
};

/**
* | output |
* | --- |
* | "Mark as done" |
*
* @param {Notes_Mark_As_Done_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const notes_mark_as_done_label = /** @type {((inputs?: Notes_Mark_As_Done_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Mark_As_Done_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_notes_mark_as_done_label(inputs)
	if (locale === "de") return de_notes_mark_as_done_label(inputs)
	if (locale === "it") return it_notes_mark_as_done_label(inputs)
	if (locale === "ru") return ru_notes_mark_as_done_label(inputs)
	if (locale === "es") return es_notes_mark_as_done_label(inputs)
	if (locale === "zh-CN") return zh_cn2_notes_mark_as_done_label(inputs)
	if (locale === "ja") return ja_notes_mark_as_done_label(inputs)
	if (locale === "hi") return hi_notes_mark_as_done_label(inputs)
	if (locale === "pt-PT") return pt_pt2_notes_mark_as_done_label(inputs)
	return en_notes_mark_as_done_label(inputs)
});